import { Tag } from 'antd'
import styled from 'styled-components'

export const StyledBrandTag = styled(Tag)`
  display: inline-flex;
  color: ${({ theme }): string => theme.colors.brand.secondary};
  border-color: ${({ theme }): string => theme.colors.brand.secondary};
  background: ${({ theme }): string => theme.colors.base.grey.grey9};
`
